import SFSegment from "./SFSegment"
import SFChiliPiper from "./SFChiliPiper"
import SFRedirect from "./SFRedirect"

export default {
    SFSegment,
    SFChiliPiper,
    SFRedirect
}